import { render, staticRenderFns } from "./MsdsPreview.vue?vue&type=template&id=3e0f7ce6&scoped=true"
import script from "./MsdsPreview.vue?vue&type=script&lang=js"
export * from "./MsdsPreview.vue?vue&type=script&lang=js"
import style0 from "./MsdsPreview.vue?vue&type=style&index=0&id=3e0f7ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0f7ce6",
  null
  
)

export default component.exports